import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=9ace3bf6&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&lang=ts"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=9ace3bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ace3bf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
